<script>
    import TagObject from '@/components/page-tag-edit/TagObject.vue';

    export default {
        props: {
            tags: Object,
            groupHeader: String,
        },
        components: {
            TagObject: TagObject,
        }
    }
</script>


<template>
    <div class="right_header mb_10">
        <label>{{ groupHeader }}</label>
    </div>
    <ul class="clear_ul">
        <TagObject
            v-for="(tagValue, tagIndex) in tags" :key="tagIndex"
            :tag="tagValue"
        />
    </ul>
</template>